import * as React from "react"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { isLoginTwoFactorState, LoginState, LoginTwoFactorState } from "../state"
import { notifications } from '../notifications';
import { MinimalLoginWidgetData } from "../login";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";

function handleSubmit<a, extra_user_info>(e:React.FormEvent<HTMLFormElement>, setState:(_: Action<LoginState<a, extra_user_info>>) => void) {
  e.preventDefault();
  setState(s => isLoginTwoFactorState(s) ? ({ ...s, status:"two factor - logging", login_data: s.login_data }) : s);
}

export function login_two_factor_form<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) { 
  return (s0:LoginTwoFactorState, readonly:boolean) : Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-two-factor-form">
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-4")}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>Two-Factor Authentication</h1>
                <p className={getClassName(options, "intro_classname", "lead")}>Enter verification code.</p>
              </header>
    
              <form onSubmit={(e) => handleSubmit(e, setState)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="pin"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      Pin
                    </label>
                    <input
                      type="text"
                      name="pin"
                      id="pin"
                      className={getClassName(options, "form_input_classname", "form-control")}
                      value={s0.login_data.pin}
                      disabled={readonly}
                      onChange={(event) => setState(s => isLoginTwoFactorState(s) ? ({
                        ...s,
                        status:"two factor",
                        login_data: {
                          ...s.login_data,
                          pin: event.currentTarget.value }
                        }) : s)
                      }
                    />
                  </div>

                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      Submit
                    </button>
    
                    <button
                      type="button"
                      className={getClassName(options, "clickable_secondary_classname", "btn btn-link ml-3")}
                      disabled={readonly}
                      onClick={() => setState(s => ({ ...s, status:"two factor - resending pin", login_data: s0.login_data }))}
                    >
                      Send new pin
                    </button>
    
                    <button
                      type="button"
                      className={getClassName(options, "clickable_tertiary_classname", "btn btn-link ml-3")}
                      disabled={readonly}
                      onClick={() => setState(s => isLoginTwoFactorState(s) ? ({
                        status: "logged out",
                        login_data: {
                          username: s.login_data.username,
                          password: s.login_data.password,
                          show_password: false }
                        }) : s)
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}
